var _rect, _text, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_20_125",
    "data-name": "Component 20 \\u2013 125",
    xmlns: "http://www.w3.org/2000/svg",
    width: 123.61,
    height: 37.08,
    viewBox: "0 0 123.61 37.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7715",
    "data-name": "Rectangle 7715",
    width: 123.61,
    height: 37.08,
    rx: 10,
    fill: "#3ea598"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Explore_more",
    "data-name": "Explore more",
    transform: "translate(15 23)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Explore more"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58237",
    "data-name": "Group 58237",
    transform: "translate(-55.448 1)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape_-_Outline",
    "data-name": "Combined-Shape - Outline",
    d: "M9.552-9.894H9.543a.88.88,0,0,1-.183-.021l-.026-.007L9.31-9.929a.71.71,0,0,1-.088-.03L9.2-9.968a.708.708,0,0,1-.082-.04l-.034-.021a.66.66,0,0,1-.067-.046,1.01,1.01,0,0,1-.1-.087L5.558-13.54a.871.871,0,0,1-.256-.621.872.872,0,0,1,.258-.62.877.877,0,0,1,.62-.256.866.866,0,0,1,.62.259l2.224,2.233.528.56.532-.564,2.22-2.229a.869.869,0,0,1,.62-.258.874.874,0,0,1,.62.256.873.873,0,0,1,.258.62.871.871,0,0,1-.256.621l-3.372,3.386h0l-.005.005h0a.867.867,0,0,1-.146.117l-.036.021a.7.7,0,0,1-.083.042l-.019.007a.709.709,0,0,1-.087.031l-.026.006-.024.006a.634.634,0,0,1-.07.014l-.049,0A.621.621,0,0,1,9.552-9.894Z",
    transform: "translate(127.485 28.968) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape_-_Outline-2",
    "data-name": "Combined-Shape - Outline",
    d: "M9.552-9.894H9.543a.88.88,0,0,1-.183-.021l-.026-.007L9.31-9.929a.71.71,0,0,1-.088-.03L9.2-9.968a.708.708,0,0,1-.082-.04l-.034-.021a.66.66,0,0,1-.067-.046,1.01,1.01,0,0,1-.1-.087L5.558-13.54a.871.871,0,0,1-.256-.621.872.872,0,0,1,.258-.62.877.877,0,0,1,.62-.256.866.866,0,0,1,.62.259l2.224,2.233.528.56.532-.564,2.22-2.229a.869.869,0,0,1,.62-.258.874.874,0,0,1,.62.256.873.873,0,0,1,.258.62.871.871,0,0,1-.256.621l-3.372,3.386h0l-.005.005h0a.867.867,0,0,1-.146.117l-.036.021a.7.7,0,0,1-.083.042l-.019.007a.709.709,0,0,1-.087.031l-.026.006-.024.006a.634.634,0,0,1-.07.014l-.049,0A.621.621,0,0,1,9.552-9.894Z",
    transform: "translate(132.485 28.968) rotate(-90)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenRectangle);
export default __webpack_public_path__ + "static/media/greenRectangle.457312bd1e08f32ad38bf5ab21048a52.svg";
export { ForwardRef as ReactComponent };